{
  "audit_title": "Audit SEO Complet",
  "audit_description": "Verificare tehnică completă a optimizărilor SEO implementate pe platforma RO Auto Market",
  "audit_for_country": "Audit SEO pentru piața din {{country}}",
  "last_check": "Ultima verificare: Ianuarie 2025",
  "seo_score": "Scor SEO",
  "passed": "Passed",
  "warnings": "Warnings",
  "failed": "Failed",
  "all_critical_passed": "✅ Toate verificările critice au trecut! Site-ul este optimizat pentru indexare.",
  "critical_checks": "Verificări critice",
  "important_checks": "Verificări importante",
  "recommended_checks": "Recomandări",
  "next_steps": "📈 Următorii pași",
  "next_step_1_title": "Optimizare Imagini",
  "next_step_1_desc": "Conversie WebP automată, lazy loading, compresia avansată",
  "next_step_2_title": "Content Expansion",
  "next_step_2_desc": "Blog cu 20+ articole SEO-optimized, ghiduri complete",
  "next_step_3_title": "Backlink Strategy",
  "next_step_3_desc": "Link building, partnerships, guest posting",
  "view_dashboard": "Vezi Dashboard Admin",
  
  "check_meta_title": "Meta Title & Description",
  "check_meta_desc": "Toate paginile au meta title și description unice, sub 60/160 caractere",
  "check_h1_title": "H1 Tags",
  "check_h1_desc": "Fiecare pagină are exact un H1 tag cu keyword principal",
  "check_alt_title": "Image Alt Text",
  "check_alt_desc": "Toate imaginile au atribute alt descriptive cu keywords",
  "check_canonical_title": "Canonical URLs",
  "check_canonical_desc": "Canonical tags implementate pentru evitarea conținutului duplicat",
  "check_robots_title": "Robots.txt",
  "check_robots_desc": "Robots.txt configurat corect, permite indexare",
  "check_sitemap_title": "Sitemap XML",
  "check_sitemap_desc": "Sitemap actualizat automat cu toate paginile importante",
  "check_schema_title": "Structured Data (Schema.org)",
  "check_schema_desc": "JSON-LD implementat pentru organization, WebSite, article, product",
  "check_og_title": "Open Graph Tags",
  "check_og_desc": "OG tags pentru Facebook, Twitter cards pentru social sharing",
  "check_mobile_title": "Mobile Responsiveness",
  "check_mobile_desc": "Design complet responsive, optimizat pentru mobile-first",
  "check_speed_title": "Page Speed",
  "check_speed_desc": "Loading time: ~2.5s. Recomandare: sub 2s pentru SEO optimal",
  "check_speed_action": "Optimizare imagini în curs",
  "check_internal_title": "Internal Linking",
  "check_internal_desc": "Link structure bună: homepage → categorii → listări → detalii",
  "check_url_title": "URL Structure",
  "check_url_desc": "URLs descriptive, clean, fără parametri excesivi",
  "check_https_title": "HTTPS",
  "check_https_desc": "Site securizat cu SSL/TLS",
  "check_breadcrumb_title": "Breadcrumb Navigation",
  "check_breadcrumb_desc": "Breadcrumbs implementate pe pagini majore",
  "check_hreflang_title": "Hreflang Tags",
  "check_hreflang_desc_ro": "Hreflang tags pentru targeting multi-regional (RO, UK, DE)",
  "check_hreflang_desc_uk": "Hreflang tags pentru targeting UK (en-GB)",
  "check_hreflang_desc_de": "Hreflang tags pentru targeting Germania (de-DE)",
  "check_vitals_title": "Core Web Vitals",
  "check_vitals_desc": "LCP: Good, FID: Good, CLS: Needs improvement",
  "check_vitals_action": "Optimizare layout shifts",
  "check_local_title": "Local SEO",
  "check_local_desc_ro": "Optimizare pentru căutări locale în România (orașe majore)",
  "check_local_desc_uk": "Optimizare pentru căutări locale în UK (orașe majore)",
  "check_local_desc_de": "Optimizare pentru căutări locale în Germania (orașe majore)",
  "check_indexing_title": "Google Indexing",
  "check_indexing_desc_ro": "Site indexat în Google.ro pentru piața românească",
  "check_indexing_desc_uk": "Necesită indexare în Google.co.uk pentru piața UK",
  "check_indexing_desc_de": "Necesită indexare în Google.de pentru piața germană",
  "explore_more_vehicles": "Descoperă mai multe vehicule",
  "all_vehicles": "Toate vehiculele",
  "cars": "Autoturisme",
  "verified_dealers": "Dealeri verificați",
  "sell_your_car": "Vinde-ți mașina",
  "similar_vehicles": "Vehicule similare care ți-ar putea plăcea"
}
